(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-description"] && !Shopify.designMode) return;
  try {
    class HotspotProductDescription extends HTMLElement {
  connectedCallback() {
    if (this.dataset.enhanced) return;
    const content = this.querySelector('.text-block');
    if (!content) return;
    const walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.parentElement.closest('.hs-manufacturer, script, style')) continue;
      const match = node.textContent.match(/^\s*(Verantwortliche Person|Hersteller(?:angaben|informationen)?)\s*:/i);
      if (!match) continue;
      const range = document.createRange();
      range.setStart(node, 0);
      range.setEnd(content, content.childNodes.length);
      const fragment = range.cloneContents();
      if (!fragment.textContent.replace(match[0], '').trim()) return;
      const details = document.createElement('details');
      details.className = 'hs-manufacturer';
      const summary = document.createElement('summary');
      summary.textContent = this.dataset.manufacturerLabel;
      const body = document.createElement('div');
      body.className = 'hs-manufacturer__body';
      body.append(fragment);
      details.append(summary, body);
      range.deleteContents();
      this.append(details);
      while (content.lastChild && !content.lastChild.textContent.trim() && !content.lastChild.querySelector?.('img, video, iframe')) {
        content.lastChild.remove();
      }
      this.dataset.enhanced = 'true';
      return;
    }
  }
}
if (!customElements.get('hotspot-product-description')) {
  customElements.define('hotspot-product-description', HotspotProductDescription);
}
  } catch(e) { console.error(e); }
})();

})();
